import { render, staticRenderFns } from "./strings.vue?vue&type=template&id=913b71a4"
import script from "./strings.vue?vue&type=script&lang=js"
export * from "./strings.vue?vue&type=script&lang=js"
import style0 from "./strings.vue?vue&type=style&index=0&id=913b71a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports